import React from "react";
import {InputJson} from "../../../nq-component";
import EmailBlastFormPresenter from "./EmailBlastFormPresenter";
import {getObjectUseCase, upsertUseCase} from '../../../usecases/object';
import withRouter from "../../../withRouter";
import BaseFormPage from "../../../base/BaseFormPage";
import NavBar from "../../../components/navbar";
import FormFactory from "../../../components/FormFactory";

class EmailBlastFormPage extends BaseFormPage {
    constructor(props) {
        super(props);
        this.state = {object: {}, advanced: false};
        this.presenter = new EmailBlastFormPresenter(this, getObjectUseCase(), upsertUseCase());
    }

    getCollectionName() {
        return "emailBlast"
    }

    onClickAdvance() {
        this.setState({advanced: !this.state.advanced});
    }

     onSubmitForm(e) {
        e.preventDefault();
        this.presenter.submit();
    }

    render() {
        const object = this.state.object;
        const advanced = this.state.advanced;
        const schema = this.getSchema(this.getCollectionName());
        if (!schema) return <h1>no schema</h1>;
        const label = this.getObjectId() === undefined ? "Create " : "Edit ";
        return (
            <>
                <NavBar
                    action={() => (
                        <div className="dropdown dropstart d-inline-block">
                            <i role="button" data-bs-toggle="dropdown" className="bi bi-three-dots-vertical"></i>
                            <div className="dropdown-menu fs-xs">
                                <button
                                    onClick={this.onClickAdvance.bind(this)}
                                    className="dropdown-item py-3">
                                    <i className='bi bi-gear pe-2'/>Toggle Advance
                                </button>
                            </div>
                        </div>
                    )}/>
                <div className="overflow-auto">
                    <div className="h-100">
                        <div className="p-3 p-lg-4">
                            <div className="d-flex align-items-start mt-3">
                            <i className="bi bi-chevron-left" style={{ fontSize: '1.5rem' }} onClick={this.onClickBack.bind(this)}></i>
                            <h1 className="fw-bold text-capitalize"> {label + (schema.label || "Email Blast")}</h1>
                            </div>
                            <div className="mt-3 bg-white border border-gray rounded p-3 px-lg-5 py-lg-4">
                                <form onSubmit={this.onSubmitForm.bind(this)}>
                                    <div className="row g-3">
                                        {
                                            advanced
                                                ?
                                                <InputJson
                                                    defaultValue={object}
                                                    onChange={this.onChange.bind(this)}
                                                    rows="15"/>
                                                :
                                                <FormFactory
                                                    schema={schema}
                                                    object={object}
                                                    onChange={this.onChange.bind(this)}/>
                                        }
                                    </div>
                                    <div className="mt-4 d-flex justify-content-center">
                                        <button type="button" className="btn btn-light fs-sm me-3 w-50 fw-bolder"
                                                onClick={this.onClickBack.bind(this)}>Cancel
                                        </button>
                                        <button type="submit" className="btn btn-primary fs-sm w-50 fw-bolder text-black">
                                                Send
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}

export default withRouter(EmailBlastFormPage);
